import React, { useState, useEffect } from 'react'
import back1 from "../../../assets/images/back.png"
import { useParams } from 'react-router-dom';
import { findTrainer } from '../../../../redux/trainerSlice';
import { useDispatch, useSelector } from 'react-redux';
// import back1 from "../../../assets/images/image1.png"
import icon1 from "../../../assets/jobIcons/icon1.svg"
import SendEmailModal from '../../../../components/Modal/SendEmailModal'
import { About } from './partials/About'
import Trainings from './partials/Trainings'
import { TfiEmail } from 'react-icons/tfi'
import ImageWithFallback from '../../../components/ImageWithFallback'
import { END_POINT } from '../../../../utils/constant'
import { formatDateTime, formatSalary } from '../../../../components/DateTimeConverter/DateTimeConverter';
import { FaBuilding, FaEnvelope, FaUsers, FaGlobe, FaMapMarkerAlt } from "react-icons/fa";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import { TfiEmail } from "react-icons/tfi";

const TrainerDetail = () => {
  const {id}= useParams()
  const dispatch = useDispatch()
  const [showModal, setshowModal] = useState(false)
  const [option, setoption] = useState(1)

  const { singleTrainer, loading, error } = useSelector((state) => state.trainer);

  useEffect(() => {
    if (id) {
      dispatch(findTrainer(id));
      // console.log(singleTrainer)
    }
  }, [id, dispatch]);

  // if (loading) return <div>Chargement...</div>;

  return (
    <>
    {/* <div className=" mb-6 rounded-lg h-56 mx-4 lg:mx-10 xl:mx-20 mt-10 bg-neutral-50" style={{backgroundImage: "url("+back1+")", objectFit: "cover", backgroundSize:"100%"}}>
 
    </div> 
    <div className="m-responsive rounded-md h-28 bg-white relative -mt-20 mb-10 rounded-40 border backdrop-shadow px-6 py-4 flex justify-between items-center">
      <div className="flex gap-4">
        <div className="  bg-gray-50 border rounded-md flex justify-center items-center w-28 h-20 overflow-hidden ">
        <ImageWithFallback src={END_POINT+"/storage"+ singleTrainer?.organisation_profile?.logo} className="  object-cover " defaultType="logo"/>
        </div>

          <div className="flex flex-col text-start justify-between py-2">
            <h1 className='text-2xl font-semibold'>{singleTrainer?.organisation_profile?.company_name}</h1>
            <div className="inline-flex gap-1 text-sm text-primary-text"> {singleTrainer?.organisation_profile?.address}</div>
          </div>        
      </div>
      

      <div className="flex gap-4">
        <button
        onClick={()=>setshowModal(true)}
        className="py-2 px-6 rounded-md bg-black text-white flex gap-1 items-center"> <TfiEmail/> Envoyer Un Mail</button>
      </div>
    </div> */}
          {/* Image en arrière-plan */}
          <div
        className="mb-6 rounded-lg h-56 mx-4 lg:mx-10 xl:mx-20 mt-10 bg-neutral-50"
        style={{
          backgroundImage: loading
            ? "none"
            : `url(${back1})`,
          objectFit: "cover",
          backgroundSize: "100%",
        }}
      >
        {loading && (
          <Skeleton
            height="100%"
            width="100%"
            highlightColor="#fbfbfb"
            baseColor="#e9e9e9"
            style={{ borderRadius: "8px" }}
          />
        )}
      </div>

      {/* Carte entreprise */}
      <div className="m-responsive rounded-md h-28 bg-white relative -mt-20 mb-10 rounded-40 border backdrop-shadow px-6 py-4 flex justify-between items-center">
        <div className="flex gap-4">
          {/* Logo de l'entreprise */}
          <div className="bg-gray-50 border rounded-md flex justify-center items-center w-28 h-20 overflow-hidden">
            {loading ? (
              <Skeleton width={112} height={80} highlightColor="#fbfbfb" baseColor="#e9e9e9"/>
            ) : (
              <ImageWithFallback
                src={END_POINT + "/storage" + singleTrainer?.organisation_profile?.logo}
                className="object-cover"
                defaultType="logo"
              />
            )}
          </div>

          {/* Nom et adresse */}
          <div className="flex flex-col text-start justify-between py-2">
            {loading ? (
              <>
                <Skeleton width={200} height={24}  highlightColor="#fbfbfb" baseColor="#e9e9e9"/>
                <Skeleton width={150} height={16}  highlightColor="#fbfbfb" baseColor="#e9e9e9"/>
              </>
            ) : (
              <>
                <h1 className="text-2xl font-semibold">
                  {singleTrainer?.organisation_profile?.company_name}
                </h1>
                <div className="inline-flex gap-1 text-sm text-primary-text">
                  {singleTrainer?.organisation_profile?.address}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Bouton d'envoi d'email */}
        <div className="flex gap-4">
          {loading ? (
            <Skeleton width={180} height={40}  highlightColor="#fbfbfb" baseColor="#e9e9e9"/>
          ) : (
            <button
              onClick={() => setshowModal(true)}
              className="py-2 px-6 rounded-md bg-black text-white flex gap-1 items-center"
            >
              <TfiEmail /> Envoyer Un Mail
            </button>
          )}
        </div>
      </div>
    
    <div className=" mb-10 flex sticky top-0 border-b m-responsive my-4 text-sm bg-white pt-2">
      <button 
      onClick={()=>setoption(1)}
      className={" px-6 py-2 border-b-2 hover:text-primary-black " + (option === 2 ? "border-b-transparent text-primary-text font-normal" : "border-b-gray-950 text-primary-black font-bold")}>A propos</button>
      <button 
      onClick={()=>setoption(2)}
      className={" px-6 py-2 border-b-2 hover:text-primary-black " + (option === 1 ? "border-b-transparent text-primary-text font-normal" : "border-b-gray-950 text-primary-black font-bold")}>
        Formation ({singleTrainer?.trainings?.length || 0})</button>    
    </div>

    <div className="p-responsive flex justify-between gap-10 mb-14">

        {/* Scrollable Content */}
        <div className="w-2/3 leading-loose text-justify text-black">
        
        {option === 1 ?
        <About item={singleTrainer}/>
        :
        <Trainings item={singleTrainer?.trainings}/>
        }
      
     </div>

     {/* Sticky Box */}
          {/* Sticky Box */}
          <div className="w-1/3 h-fit bg-white border-2 border-gray-300 lg:block hidden rounded-2xl sticky top-20">
      <h5 className="text-xl font-semibold py-4 text-start px-6">Information Générale</h5>

      {/* Nom de l'entreprise */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <FaBuilding className="text-2xl text-primary" />
        <div className="flex flex-col text-start">
          <div className="text-sm text-primary-text">Nom</div>
          <div className="font-semibold">{singleTrainer?.organisation_profile?.company_name || "N/A"}</div>
        </div>
      </div>

      {/* Email de contact */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <FaEnvelope className="text-2xl text-primary" />
        <div className="flex flex-col text-start">
          <div className="text-sm text-primary-text">Email</div>
          <div className="font-semibold">{singleTrainer?.organisation_profile?.contact_email || "N/A"}</div>
        </div>
      </div>

      {/* Nombre d'employés */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <FaUsers className="text-2xl text-primary" />
        <div className="flex flex-col text-start">
          <div className="text-sm text-primary-text">Nombre d'employés</div>
          <div className="font-semibold">{singleTrainer?.organisation_profile?.total_emloyees || "N/A"}</div>
        </div>
      </div>

      {/* Adresse */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <FaMapMarkerAlt className="text-2xl text-primary" />
        <div className="flex flex-col text-start">
          <div className="text-sm text-primary-text">Adresse</div>
          <div className="font-semibold">{singleTrainer?.organisation_profile?.address || "N/A"}</div>
        </div>
      </div>

      {/* Site web */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <FaGlobe className="text-2xl text-primary" />
        <div className="flex flex-col text-start">
          <div className="text-sm text-primary-text">Site Web</div>
          <a
            href={singleTrainer?.organisation_profile?.website_url}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-blue-600 hover:underline"
          >
            {singleTrainer?.organisation_profile?.website_url || "Aucun"}
          </a>
        </div>
      </div>
    </div>
      {/* <div className="w-1/3 h-[460px] bg-white  border-2 border-gray-300 rounded-2xl sticky top-20">
      <h5 className='text-xl font-semibold py-4 text-start px-6'>Informations supplémentaires</h5>
      <div className="divide-y">
      {[
        { label: "Localisation", value: singleTrainer?.organisation_profile?.address },
        { label: "Date de fondation", value: singleTrainer?.organisation_profile?.build_at },
        // { label: "Droit", value: formatSalary(singleTrainer?.fees) },
        { label: "Site web", value: singleTrainer?.organisation_profile?.website_url || "Aucun" },
        { label: "Email", value: singleTrainer?.organisation_profile?.contact_email},
        { label: "Téléphone", value: singleTrainer?.organisation_profile?.phone || "+261 45 804 65" },
      ].map((item)=>{
        return(
        <div className="-b flex gap-4 items-center py-4 mx-6">
          <img src={icon1} alt="..." />
          <div className="flex justify-between flex-col text-start">
            <div className='text-sm text-primary-text'>{item.label}</div>
            <div className='font-semibold'>{item.value}</div>
          </div>
        </div>  
        )
        })}
      </div> */}
     
        {/* <div className="w-full px-4">       
        </div>
      </div> */}

    </div>
  <SendEmailModal isOpen={showModal} onClose={()=>setshowModal(false)}></SendEmailModal>
  </>
  );
};

export default TrainerDetail;
